import { useConditionStore } from "../condition/conditions.store";
import type { IncidentTriggerItem } from "./IncidentTriggerItem";

export function getIncidentTriggerCopyData(
  incidentTrigger: IncidentTriggerItem
) {
  const data = [];

  data.push(incidentTrigger);

  const conditionStore = useConditionStore();
  const conditions = conditionStore.getBySource(incidentTrigger);
  for (const condition of conditions) {
    data.push(condition);
  }

  return data;
}
